import styled from 'styled-components'

interface IFinancialAccountSummaryCardStyledProps {}

export const FinancialAccountSummaryCardStyled = styled.div<IFinancialAccountSummaryCardStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
